<template>
    <div class="h-full w-full">
        Construyendo la seccion de: Concursos
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>